import React from 'react'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/SvgIcon/index.web'
import type { TableHeaderData } from '@ui-kit/components/Table/types'

import * as styles from './styles'

interface Props {
  headerItems: TableHeaderData[]
}

const TableHeader = (props: Props) => {
  const { row, column, emptyColumn, text } = styles.tableHeader()
  return (
    <div className={row()}>
      <div className={emptyColumn()} />
      {props.headerItems.map((item) => (
        <div className={column()} key={item.key}>
          {item.icon && <Icon imgSrc={IMAGE.icons.medium[item.icon]} />}
          <span className={text()}>{item.title}</span>
        </div>
      ))}
    </div>
  )
}

export default TableHeader
